import { MemberUser } from '../../dto/member-user';
import { SubmissionRequest } from './submission-request';

export class ChangeNameRequest extends SubmissionRequest {
  public firstName!: string;
  public middleName!: string | null;
  public preferredName!: string | null;
  public lastName!: string;

  // Not From API
  public files: File[] = [];

  constructor(user?: MemberUser) {
    super();
    if (!!user) {
      this.firstName = user.firstName;
      this.middleName = user.middleName;
      this.lastName = user.lastName;
      this.preferredName = user.preferredName;
      this.memberId = user.id;
    }
  }
}
